import React, { forwardRef, ForwardRefExoticComponent } from "react";
import { CheckBoxProps } from "./Checkbox.types";
import "./Checkbox.scss";
import { useState } from "react";
import cx from "classnames";

export const CheckBox: ForwardRefExoticComponent<
  CheckBoxProps & React.RefAttributes<HTMLInputElement>
> = forwardRef((props, ref) => {
  const {
    className,
    disabled = false,
    onChange,
    onClick = () => false,
    label,
    labelClass,
    checkBoxClassName,
    name,
    checked,
    dataTestId,
  } = props;

  const [isChecked, setIsChecked] = useState(checked);

  const handleOnChange = (e) => {
    setIsChecked(!isChecked);
    if (onChange) {
      onChange(e);
    }
  };
  return (
    <div
      className={cx("alteon-checkbox-div", className)}
      data-testid={dataTestId}
    >
      <input
        checked={isChecked}
        className={cx("alteon-checkmark", checkBoxClassName)}
        disabled={disabled}
        name={name}
        onChange={handleOnChange}
        onClick={onClick}
        ref={ref}
        type={"checkbox"}
      />
      
      <label
        htmlFor={name}
        className={`${labelClass} alteon-checkbox-label-text`}
      >
        {label}
      </label>
    </div>
  );
});
